import { Navigate, useNavigate } from 'react-router-dom'

import { Box, Button, Text, Touchable, useToggle } from '@factorialco/deprecated-design-system'

import FormRow from 'modules/core/components/FormRow'
import RadioInput from 'modules/core/components/Inputs/FilterSelect/SelectOption/RadioInput'
import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { canCreateReviews } from 'modules/reviews/lib/canCreateReviews'

export const NewPerformanceReview: React.FC<{
  onClose: () => void
  onSubmitCustomReview: () => void
  onSubmitReviewFromTemplate: () => void
}> = ({ onClose: onModalClose, onSubmitCustomReview, onSubmitReviewFromTemplate }) => {
  const { navigation } = useNavigation()

  const [customReviewSelection, toggleCustomReviewSelection] = useToggle(false)
  const navigate = useNavigate()

  const onClose = () => {
    track(trackingEvents.reviews.startReviewCancel)
    onModalClose()
  }

  const submit = async () => {
    if (customReviewSelection) {
      onSubmitCustomReview()
    } else {
      onSubmitReviewFromTemplate()
    }
  }

  if (!canCreateReviews()) {
    return <Navigate to={navigation.performance.reviews.fullPath()}></Navigate>
  }

  return (
    <Modal
      title={i18n.t('surveys.performance.selection.title')}
      description={i18n.t('surveys.performance.selection.description')}
      illustration="surveys"
      onClose={onClose}
      onSubmit={submit}
      footer={<Button submit>{i18n.t('common.next')}</Button>}
      progress={{ amount: 1, total: 2 }}
    >
      <FormRow>
        <Box
          gap="s16"
          border={{
            all: {
              width: 's2',
              style: 'solid',
              color: !customReviewSelection ? 'viridian1000' : 'grey400',
            },
          }}
          borderRadius={{
            all: 'abs008',
          }}
          padding="s16"
        >
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="semibold">
              {i18n.t('surveys.performance.selection.template_title')}
            </Text.Normal>
            <Touchable
              onClick={toggleCustomReviewSelection(false)}
              aria-label="Use prepared review template"
            >
              <RadioInput selected={!customReviewSelection} />
            </Touchable>
          </Box>
          <Text.Normal>{i18n.t('surveys.performance.selection.template_description')}</Text.Normal>
        </Box>
      </FormRow>
      <FormRow>
        <Box
          gap="s16"
          border={{
            all: {
              width: 's2',
              style: 'solid',
              color: customReviewSelection ? 'viridian1000' : 'grey400',
            },
          }}
          borderRadius={{
            all: 'abs008',
          }}
          padding="s16"
        >
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="semibold">
              {i18n.t('surveys.performance.selection.custom_title')}
            </Text.Normal>
            <Touchable
              onClick={toggleCustomReviewSelection(true)}
              aria-label="Use custom review setup"
            >
              <RadioInput selected={customReviewSelection} />
            </Touchable>
          </Box>
          <Text.Normal>{i18n.t('surveys.performance.selection.custom_description')}</Text.Normal>
        </Box>
      </FormRow>
    </Modal>
  )
}
